module.exports = __webpack_public_path__ + "static/media/jq1.e631c7e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/jq1.png
// module id = 1788
// module chunks = 0 1